import * as React from 'react'

const Footer = () => {
  return(
    <footer id="footer">
      <div className="container">
        <div className="ft_content">
          <div className="logo">
            <a href="/home/#">
              <img src="/src/img/logo.svg" />
            </a>
          </div>
          <ul className="util_menu">
            <li>
              <a href="/">HOME</a>
            </li>
            <li>
              <a href="#privacy_modal" rel="modal:open">
                개인정보처리방침
              </a>
            </li>
          </ul>
          <ul className="ft_info">
            <li>
              <p>주식회사</p>
              <span>엘케이에스컴퍼니</span>
            </li>
            <li>
              <p>대표자</p>
              <span>손미희</span>
            </li>
            <li>
              <p>사업자등록번호</p>
              <span>214-88-44658</span>
            </li>
            <li>
              <p>주소</p>
              <span>서울특별시 강서구 마곡서로 101, 824호</span>
            </li>
            <li>
              <p>문의전화</p>
              <span>010-2608-8615</span>
            </li>
            <li>
              <p>e-mail</p>
              <span>lkscompany@naver.com</span>
            </li>
            <li>
              <p>통신판매업신고</p>
              <span>제 2024-서울강서-1359 호</span>
            </li>
            {/* <li> */}
            {/*     <p>개인정보처리 책임자</p> */}
            {/*     <span>000 <a href="#">(000@hanmail.net)</a></span> */}
            {/* </li> */}
          </ul>
          <span>
            Copyrights ⓒ (주)엘케이에스컴퍼니. 2024 All rights reserved
          </span>
        </div>
      </div>
      <div id="privacy_modal" className="modal">
        <div className="box">
          <h2>개인정보 수집 및 이용 동의</h2>
          <div className="privacy_cont">
            <dl>
              <dt>1. 수집하는 개인정보의 항목</dt>
              <dd>
                (주)엘케이에스컴퍼니(이하 '회사')는 비상주 오피스 이용 계약의
                체결과 이행을 위해 아래와 같은 개인정보를 수집합니다.
              </dd>
              <dd>
                - 필수 항목 : 대표자 성명, 대표자 연락처, 이메일, 주소, 상호,
                업종, 담당자 성명, 담당자 연락처, 서명
              </dd>
              <dd>
                - 해당 시 수집 : 사업자등록번호(사업자인 경우),
                법인등록번호(법인인 경우)
              </dd>
              <dd>
                - 첨부 서류 : 대표자 신분증 사본(필수), 사업자등록증 사본,
                법인 등기사항증명서, 대리인 위임장(해당 시)
              </dd>
              <dd>
                - 결제 시 : 주문번호, 결제 금액, 결제 결과
              </dd>
            </dl>
            <dl>
              <dt>2. 고유식별정보(주민등록번호)의 처리</dt>
              <dd>
                - 처리 항목 : 주민등록번호(신분증 사본에 기재된 정보 포함)
              </dd>
              <dd>
                - 처리 근거 : 부가가치세법 제32조(세금계산서 발급 시 공급받는
                자가 사업자가 아닌 경우의 기재사항)
              </dd>
              <dd>
                - 주민등록번호는 법령에서 정한 목적 외로 이용하지 않습니다.
              </dd>
            </dl>
            <dl>
              <dt>3. 개인정보의 수집 및 이용 목적</dt>
              <dd>
                수집한 개인정보는 아래 목적으로만 이용하며, 목적이 바뀌는
                경우에는 미리 동의를 받습니다.
              </dd>
              <dd>- 비상주 오피스 이용 계약의 체결, 계약서 작성 및 계약 이행</dd>
              <dd>- 이용 요금 결제 및 세금계산서 발급</dd>
              <dd>- 우편물 수령, 메일 발송 및 실물 발송 서비스 제공</dd>
              <dd>- 계약 관련 안내 및 고객 문의 응대</dd>
            </dl>
            <dl>
              <dt>4. 개인정보 수집 방법</dt>
              <dd>
                - 홈페이지 계약 신청 화면에서 이용자가 직접 입력하거나 서류를
                첨부하는 방법으로 수집합니다.
              </dd>
            </dl>
            <dl>
              <dt>5. 개인정보의 보유 및 이용 기간</dt>
              <dd>
                개인정보는 계약 종료 시까지 보유하며, 이용 목적이 달성되면 지체
                없이 파기합니다. 다만, 관계 법령에 따라 보존이 필요한 정보는
                아래 기간 동안 해당 목적으로만 보관합니다.
              </dd>
              <dd>
                - 계약서, 결제 및 세금계산서 관련 기록 : 5년 (국세기본법
                제85조의3, 부가가치세법 제71조)
              </dd>
            </dl>
            <dl>
              <dt>6. 개인정보 처리의 위탁</dt>
              <dd>
                - 결제 처리 : 쿠키페이(결제 대행) - 주문번호, 상품명, 결제 금액,
                대표자 성명, 대표자 연락처
              </dd>
            </dl>
            <dl>
              <dt>7. 동의를 거부할 권리</dt>
              <dd>
                이용자는 개인정보 수집 및 이용에 동의하지 않을 권리가 있습니다.
                다만, 필수 항목에 동의하지 않으시면 비상주 오피스 이용 계약을
                체결할 수 없습니다.
              </dd>
            </dl>
          </div>
        </div>
      </div>

    </footer>
  )
}

export default Footer
